app.service('relatedAccessories', function (cartManager, log, broker, pageConfig, modal, productDetailsModal, simpleToastr) {
	function add(params) {
		var basket = pageConfig.getData('basket');
		var parent = basket.items.filter(function (e) {
			return e.id == params.parentId;
		});
		var logEventData = {
			id: 'to_cart',
			f03: 'cart_step_1',
			f04: '',
			f05: 'akc',
			f06: '',
			f07: 'accessory_card',
			f08: 'button',
			f09: 'new',
			f10: '',
		}
		if (parent.length) {
			parent = parent[0];
			let product = parent.relatedAccessory.filter(function (e) {
				return e.id == params.productId;
			});
			if (product.length) {
				product = product[0];
				var data = {
					item_name: product.name,//nazwa produktu (wartość zmienna)
					item_id: product.plu, //numer PLU (wartość zmienna)
					price: product.price, //cena z uwzględnieniem przeceny! (wartość zmienna)  
					item_brand: product.brand,  //marka (wartość zmienna)       
					item_list_name: 'Koszyk - Akcesoria', // nazwa listy produktowej (stała wartość)
					item_list_id: 'Koszyk', //identyfikator listy produktowej (stała wartość)
					dimension31: "Towar", //rodzaj produktu (Towar | Usługa | Ubezpieczenie) (wartość zmienna)
					dimension14: parent.name, //item_name produktu podstawowego
					dimension15: parent.plu //item_id produktu podstawowego
				}
				log.event({
					id: 'tocart',
					f03: "BASKET-ACCESSORY",
					f04: product.plu,
					f05: product.position,
					f06: parent.plu,
					f07: 'basket',
				});
				logEventData.f04 = product.plu;
				logEventData.f06 = parent.plu;
				logEventData.f10 = parent.isInstalmentPrice ? 'installment' : 'cash';

				if (product.oldPrice.length) {
					data.metric1 = product.oldPrice; //oryginalna cena produktu bez zniżki (wartość zmienna)
				}
				if (product.nodes) {
					if (product.nodes[0]) {
						data.item_category = product.nodes[0].name; //Kategoria produktu (zmienna wartość)    
						if (product.nodes[1]) {
							data.item_category2 = product.nodes[1].name; //Kategoria produktu 2 (zmienna wartość)     
							if (product.nodes[2]) {
								data.item_category3 = product.nodes[2].name; //Kategoria produktu 3 (zmienna wartość)   
							}
						}
					}
				}
				if (parent.nodes) {
					if (parent.nodes[0]) {
						data.dimension16 = parent.nodes[0].name; //Kategoria produktu (zmienna wartość)    
						if (parent.nodes[1]) {
							data.dimension17 = parent.nodes[1].name; //Kategoria produktu 2 (zmienna wartość)     
							if (parent.nodes[2]) {
								data.dimension18 = parent.nodes[2].name; //Kategoria produktu 3 (zmienna wartość)   
							}
						}
					}
				}
				UA.push({
					event: "add_to_cart",
					ecommerce: {
						items: [
							data
						]
					}
				});
			}
		}

		cartManager.simpleAddProduct({
			productId: params.productId,
			addedFrom: 'CART_EDIT'
		}, function () {
			simpleToastr.afterReloadMessage(`<h2>Produkt dodany do koszyka</h2><p>${params.productName}</p>`);
			broker.trigger('REFRESH_BASKET_VIEW');
		}, logEventData);
	}
	function right($el) {
		const $list = $el.closest('.list');
		if ($list.data('size') > 1) {
			let scroll = $list.attr('data-scroll') / 1 || 0;
			scroll++;
			$list.attr('data-scroll', scroll);
		}
	}
	function left($el) {
		const $list = $el.closest('.list');
		if ($list.data('size') > 1) {
			let scroll = $list.attr('data-scroll') / 1 || 0;
			scroll--;
			if (scroll) {
				$list.attr('data-scroll', scroll);
			} else {
				$list.removeAttr('data-scroll');
			}
		}
	}
	function init() {
		const $list = $('.related-accessories .list');

		$('.js-related-product', $list).click(function (e) {
			if (!($(e.target).is('a.js-energy-card') || $(e.target).is('a.js-energy-label'))) {
				const productName = $(this).find('.related-product-name').text().trim();
				productDetailsModal.open({
					productId: $(this).data('product'),
					productPlu: $(this).data('product-plu'),
					parentId: $(this).data('parent'),
					callbackAdded: function () {
						simpleToastr.afterReloadMessage(`<h2>Produkt dodany do koszyka</h2><p>${productName}</p>`);
						broker.trigger('REFRESH_BASKET_VIEW');
					}
				});
				UA.interaction('Koszyk - K1', 'Warstwa ze szczegółami akcesorium', 'Kliknięcie');
			}
		});
		$('.js-add-related-accessory', $list).click(function (event) {

			add({
				productId :$(this).data('product'),
				parentId: $(this).data('parent'),
				productName: $(this).parents('.related-product-content').find('.related-product-name').text().trim()
			});
			event.stopPropagation();
		});
		$('.js-slide-right', $list).click(function () {
			right($(this));
		});
		$('.js-slide-left', $list).click(function () {
			left($(this));
		});

	}
	return {
		init
	};
});
